import { MonitorPlay } from "lucide-react";
import { cn } from "@/lib/utils";
import { ProductPreview } from "@/components/ProductPreview";

export const PreviewCard = ({ src, screen, title, caption, testId, className }) => {
  return (
    <figure
      data-testid={testId}
      className={cn(
        "overflow-hidden rounded-lg border border-[color:rgba(10,27,51,0.14)] bg-white shadow-[0_10px_30px_rgba(7,20,39,0.08)]",
        className
      )}
    >
      <div className="flex items-center justify-between border-b border-[color:rgba(10,27,51,0.14)] bg-[#eef2f7] px-4 py-3">
        <span className="flex items-center gap-2 text-xs font-semibold leading-5 text-[var(--ibp-ink)]">
          <MonitorPlay className="h-4 w-4 text-[#B7791F]" aria-hidden="true" />
          {title}
        </span>
        <span className="hidden text-[10px] font-semibold uppercase tracking-wide text-[color:rgba(11,18,32,0.48)] sm:inline">
          Interface preview
        </span>
      </div>
      <div className="bg-[#d7dee9] p-2 sm:p-3">
        {screen ? (
          <ProductPreview screen={screen} />
        ) : (
          <img
            src={src}
            alt={`${title} — sample screen from the Illinois Broker Prep online study platform`}
            loading="lazy"
            className="mx-auto w-full rounded-lg shadow-[0_14px_34px_rgba(7,20,39,0.26)] ring-1 ring-[color:rgba(7,20,39,0.14)]"
          />
        )}
      </div>
      {caption && (
        <figcaption className="px-4 py-4 text-sm leading-6 text-[color:rgba(11,18,32,0.78)]">
          {caption}
        </figcaption>
      )}
    </figure>
  );
};

export default PreviewCard;
